// extracted by mini-css-extract-plugin
export default {"card":"styles_card__P7aZW","label":"styles_label__OOEdU","text":"styles_text__QC69V","link":"styles_link__QeqIC","copiedTooltip":"styles_copiedTooltip__u0myI"};